// extracted by mini-css-extract-plugin
export default {"item":"ingredient_item__bs-Mf","price":"ingredient_price__jpZ+1","name":"ingredient_name__R6+oU"};